module.exports = __webpack_public_path__ + "static/nav-bg-340ec4126b5f85f72fe54f371b9fe161.jpg";